import { Pipe, PipeTransform } from '@angular/core';
import { PluralizedListPipe } from '../other/pluralized-list.pipe';
import { Endorsement } from '@lockton-apps/shared/interfaces';
import { map } from 'lodash';
import { EndorsementMetaPipe } from './endorsement-meta.pipe';

@Pipe({
  name: 'pluralizedEndorsementList',
  standalone: true,
})
export class PluralizedEndorsementsListPipe implements PipeTransform {
  constructor(
    private readonly pluralizedList: PluralizedListPipe,
    private readonly endorsementMeta: EndorsementMetaPipe
  ) {}

  transform(endorsements: Endorsement[]): string {
    return this.pluralizedList.transform(
      map(endorsements, ({ type }: Endorsement) => {
        return this.endorsementMeta.transform(type).title;
      })
    );
  }
}
